import { useEffect, useMemo } from "react";
import useGlobalPreferencesStore, {
  ETheme,
} from "src/store/useGlobalPreferencesStore";

export default function useTheme() {
  const location = window.location;
  const { setTheme, theme } = useGlobalPreferencesStore();

  const isDarkMode = useMemo(() => {
    return theme === "dark";
  }, [theme]);

  const updateThemeMetaTags = () => {
    var link = document.createElement("meta");
    link.setAttribute("name", "theme-color");
    const isLogin = location.pathname === "/";
    if (isDarkMode) {
      if (isLogin) {
        // link.content = "#00d3f2";
      } else {
      }
      link.content = "#111827";
    } else {
      if (isLogin) {
        // link.content = "#dbeafe";
      } else {
      }
      link.content = "#172554";
    }

    const prev = document?.querySelectorAll?.('meta[name="theme-color"]');

    if (prev?.length) {
      prev?.forEach((el: any) => {
        el?.remove?.();
      });
    }
    document?.getElementsByTagName?.("head")[0].appendChild(link);
  };

  useEffect(() => {
    document.body.classList.toggle("dark", isDarkMode);
    if (!isDarkMode) {
      setTheme(ETheme.LIGHT);
    } else {
      setTheme(ETheme.DARK);
    }
    updateThemeMetaTags();
  }, [isDarkMode, location]);

  return {
    isDarkMode,
    setDarkMode: (darkMode: boolean) => {
      if (darkMode) {
        setTheme(ETheme.DARK);
      } else {
        setTheme(ETheme.LIGHT);
      }
    },
    updateThemeMetaTags,
  };
}
